import * as React from 'react'
import { TableRow, TableCell } from '@mui/material'

import CustomCell from './CustomCell'

const CustomGroupRow = (props) => {
  let colSpan = props.columns.filter((columnDef) => !columnDef.hidden).length
  props.options.selection && colSpan++
  props.detailPanel && colSpan++
  props.actions && props.actions.length > 0 && colSpan++
  const column = props.groups[props.level]

  let detail

  if (props.groups.length > props.level + 1) {
    // Is there another group
    detail = props.groupData.groups.map((groupData, index) => (
      <props.components.GroupRow
        actions={props.actions}
        key={groupData.value || '' + index}
        columns={props.columns}
        components={props.components}
        detailPanel={props.detailPanel}
        getFieldValue={props.getFieldValue}
        groupData={groupData}
        groups={props.groups}
        icons={props.icons}
        level={props.level + 1}
        path={[...props.path, index]}
        onGroupExpandChanged={props.onGroupExpandChanged}
        onRowSelected={props.onRowSelected}
        onRowClick={props.onRowClick}
        onToggleDetailPanel={props.onToggleDetailPanel}
        onTreeExpandChanged={props.onTreeExpandChanged}
        onEditingCanceled={props.onEditingCanceled}
        onEditingApproved={props.onEditingApproved}
        options={props.options}
        hasAnyEditingRow={props.hasAnyEditingRow}
        isTreeData={props.isTreeData}
      />
    ))
  } else {
    detail = props.groupData.data.map((rowData, index) => {
      if (rowData.tableData.editing) {
        return (
          <props.components.EditRow
            columns={props.columns}
            components={props.components}
            data={rowData}
            icons={props.icons}
            path={[...props.path, index]}
            localization={props.localization}
            key={index}
            mode={rowData.tableData.editing}
            options={props.options}
            isTreeData={props.isTreeData}
            detailPanel={props.detailPanel}
            onEditingCanceled={props.onEditingCanceled}
            onEditingApproved={props.onEditingApproved}
            getFieldValue={props.getFieldValue}
          />
        )
      } else {
        return (
          <props.components.Row
            actions={props.actions}
            key={index}
            columns={props.columns}
            components={props.components}
            data={rowData}
            detailPanel={props.detailPanel}
            getFieldValue={props.getFieldValue}
            icons={props.icons}
            path={[...props.path, index]}
            onRowSelected={props.onRowSelected}
            onRowClick={props.onRowClick}
            onToggleDetailPanel={props.onToggleDetailPanel}
            options={props.options}
            isTreeData={props.isTreeData}
            onTreeExpandChanged={props.onTreeExpandChanged}
            onEditingCanceled={props.onEditingCanceled}
            onEditingApproved={props.onEditingApproved}
            hasAnyEditingRow={props.hasAnyEditingRow}
          />
        )
      }
    })
  }

  const freeCells = []
  for (let i = 0; i < props.level; i++) {
    freeCells.push(<TableCell padding="checkbox" key={i} />)
  }

  let value = props.groupData.value
  if (column.lookup) {
    value = column.lookup[value]
  }

  let title = column.title
  if (typeof title !== 'string') {
    title = React.cloneElement(title)
  }

  return (
    <>
      <TableRow>
        {freeCells}
        <CustomCell
          colSpan={colSpan}
          padding="none"
          columnDef={column}
          value={value}
          icons={props.icons}
          groupData={props.groupData}
        >
          <div className="d-flex flex-row align-items-center justify-content-between p-1">
            <div className="flex-column d-flex text-left">
              <h6 className="my-auto">{props.groupData.value}</h6>
            </div>
          </div>
        </CustomCell>
      </TableRow>
      {detail}
    </>
  )
}

export default CustomGroupRow
